<div class="wr-images-widget px-4" [style.background]="background()" [style.text-align]="textAlign()" [style.padding-top]="paddingTop()" [style.padding-bottom]="paddingBottom()">

  @if (widget()?.title || widget()?.subtitle) {
  <div class="px-1">
    <div class="mb-2">
      @if (widget()?.title) {
        <div
          class="title"
          [style.color]="titleColor()"
          [style.font-family]="titleFont()"
        >
        {{ widget()?.title }}
      </div>
      }
      @if (widget()?.subtitle) {
        <div
          class="subtitle"
          [style.color]="subtitleColor()"
          [style.font-family]="subtitleFont()"
        >
          {{ widget()?.subtitle }}
        </div>
      }
    </div>
  </div>
  }

  @if (isCarousel()) {
    <div class="relative px-1">
      <div
        class="relative overflow-hidden"
        [style.border-radius.px]="cornerRadius()"
        [style.aspect-ratio]="carouselAspect()"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)"
        (pointercancel)="onPointerUp($event)"
        style="touch-action: pan-y;"
      >
        @if (images().length > 0) {
          <div class="absolute inset-0 overflow-hidden">
            <div
            class="h-full w-full flex"
            [style.transform]="trackTransform()"
            [style.transition]="trackTransition()"
            (transitionend)="onTrackTransitionEnd($event)"
            >
              <div class="w-full h-full shrink-0 relative" aria-hidden="true">
                @if (prevImage(); as im) {
                  <ng-container
                    [ngTemplateOutlet]="carouselContent"
                    [ngTemplateOutletContext]="{ $implicit: im }"
                  ></ng-container>
                }
              </div>
              <div class="w-full h-full shrink-0 relative">
                @if (activeImage(); as im) {
                  <ng-container
                    [ngTemplateOutlet]="carouselContent"
                    [ngTemplateOutletContext]="{ $implicit: im }"
                  ></ng-container>
                }
              </div>
              <div class="w-full h-full shrink-0 relative" aria-hidden="true">
                @if (nextImage(); as im) {
                  <ng-container
                    [ngTemplateOutlet]="carouselContent"
                    [ngTemplateOutletContext]="{ $implicit: im }"
                  ></ng-container>
                }
              </div>
            </div>
          </div>


          <div aria-live="polite" aria-atomic="true" class="sr-only">
            {{ activeImage() ? altText(activeImage()!) : '' }}
            ({{ activeIndex() + 1 }} / {{ images().length }})
          </div>

          <ng-template #carouselContent let-im>
            @if (safeLink(im); as href) {
              <a
                [href]="href"
                target="_blank"
                rel="noopener noreferrer"
                class="block w-full h-full hover:opacity-90 transition"
                (pointerdown)="$event.stopPropagation()"
              >
                <ng-container
                  [ngTemplateOutlet]="carouselSlide"
                  [ngTemplateOutletContext]="{ $implicit: im }"
                ></ng-container>
              </a>
            } @else {
              <ng-container
                [ngTemplateOutlet]="carouselSlide"
                [ngTemplateOutletContext]="{ $implicit: im }"
              ></ng-container>
            }
          </ng-template>
        }

        <button
          type="button"
          class="carousel-button left-2 top-1/2 -translate-y-1/2 z-10 px-2 py-1 rounded text-white"
          (pointerdown)="$event.stopPropagation()"
          (click)="$event.stopPropagation(); prev()"
          aria-hidden="true"
          aria-label="Previous image"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-12 h-12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>

        <button
          type="button"
          class="carousel-button right-2 top-1/2 -translate-y-1/2 z-10 px-2 py-1 rounded text-white"
          (pointerdown)="$event.stopPropagation()"
          (click)="$event.stopPropagation(); next()"
          aria-label="Next image"
          aria-hidden="true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-12 h-12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>


        <div class="absolute bottom-2 left-0 right-0 z-10 flex justify-center gap-3 mb-2">
          @for (im of images(); track im.id; let idx = $index) {
            <button
              type="button"
              class="carousel-control p-2 -m-2 hover:opacity-90"
              style="cursor: pointer;"
              (pointerdown)="$event.stopPropagation()"
              (click)="$event.stopPropagation(); goTo(idx)"
              [attr.aria-label]="'Go to image ' + (idx + 1)"
              [attr.aria-current]="idx === activeIndex() ? 'true' : null"
            >
              <span
                class="block w-2.5 h-2.5 rounded-full"
                [style.background]="idx === activeIndex() ? dotActive() : dotInactive()"
                style="filter: drop-shadow(2px 4px 6px black); opacity: 0.9;"
              ></span>
            </button>
          }
        </div>

        <ng-template #carouselSlide let-im>
          <div class="absolute inset-0 flex items-center justify-center">
            <div
              class="h-full flex items-center justify-center"
              style="max-width: 100%; overflow: hidden;"
              [style.aspect-ratio]="carouselAspect()"
              [style.border-radius.px]="cornerRadius()"
            >
              <img
                class="block w-full"
                [style.border-radius.px]="cornerRadius()"
                [src]="imgSrc(im)"
                [alt]="altText(im)"
                (error)="onImgError($event, im)"
                (load)="im === images()[0] && onFirstImageLoad($event)"
                [style.filter]="im.title ? 'brightness(0.9)' : null"
              />
            </div>
          </div>

          @if (im.title) {
            <div class="inset-0 items-center text-white px-2 image-title">
              <span [style.font-family]="titleFont()">{{ im.title }}</span>
            </div>
          }
        </ng-template>
      </div>
    </div>
  }

  @else {
    <!-- Grid layouts -->
    <div class="px-1">
      @switch (layout()) {
        @case ('twoHorizontal') {
          <div class="grid grid-cols-2 gap-2 items-start">
            @for (im of firstN(2); track im.id) {
              <ng-container
                [ngTemplateOutlet]="imageTile"
                [ngTemplateOutletContext]="{ $implicit: im, mode: 'grid', ar: twoHorizontalAspect() }"
              ></ng-container>
            }
          </div>
        }
        @case ('twoVertical') {
          <div class="grid grid-cols-1 gap-2 items-start">
            @for (im of firstN(2); track im.id) {
              <ng-container
                [ngTemplateOutlet]="imageTile"
                [ngTemplateOutletContext]="{ $implicit: im, mode: 'grid', ar: '16 / 9' }"
              ></ng-container>
            }
          </div>
        }

        @case ('threeLayout1') {
          <div class="grid grid-cols-2 gap-2 items-stretch">
            <div class="h-full">
              @if (images()?.[0]; as im0) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: im0, fillH: true }"
                ></ng-container>
              }
            </div>

            <div class="flex flex-col gap-2">
              @if (images()?.[1]; as im1) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: im1, ar: '16 / 9' }"
                ></ng-container>
              }
              @if (images()?.[2]; as im2) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: im2, ar: '1 / 1' }"
                ></ng-container>
              }
            </div>
          </div>
        }

        @case ('threeLayout2') {
          <div class="grid grid-cols-2 gap-2 items-stretch">
            <div class="flex flex-col gap-2">
              @if (images()?.[0]; as im0) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: im0, ar: '16 / 9' }"
                ></ng-container>
              }
              @if (images()?.[2]; as im2) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: im2, ar: '1 / 1' }"
                ></ng-container>
              }
            </div>
            <div class="h-full">
              @if (images()?.[1]; as im1) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: im1, fillH: true }"
                ></ng-container>
              }
            </div>
          </div>
        }

        @case ('fourLayout1') {
          <div class="grid grid-cols-2 gap-2 items-stretch">
            <!-- column 1 -->
            <div class="flex flex-col gap-2 h-full">
              @if (images()?.[0]; as a) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: a, ar: '1 / 1' }"
                ></ng-container>
              }
              @if (images()?.[2]; as c) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: c, fillH: true }"
                ></ng-container>
              }
            </div>

            <!-- column 2 -->
            <div class="flex flex-col gap-2 h-full">
              @if (images()?.[1]; as b) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: b, fillH: true }"
                ></ng-container>
              }
              @if (images()?.[3]; as d) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: d, ar: '16 / 9' }"
                ></ng-container>
              }
            </div>
          </div>
        }

        @case ('fourLayout2') {
          <div class="grid grid-cols-2 gap-2 items-stretch">
            <!-- column 1 -->
            <div class="flex flex-col gap-2 h-full">
              @if (images()?.[0]; as a) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: a, fillH: true }"
                ></ng-container>
              }
              @if (images()?.[2]; as c) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: c, ar: '16 / 9' }"
                ></ng-container>
              }
            </div>

            <!-- column 2 -->
            <div class="flex flex-col gap-2 h-full">
              @if (images()?.[1]; as b) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: b, ar: '1 / 1' }"
                ></ng-container>
              }
              @if (images()?.[3]; as d) {
                <ng-container
                  [ngTemplateOutlet]="imageTile"
                  [ngTemplateOutletContext]="{ $implicit: d, fillH: true }"
                ></ng-container>
              }
            </div>
          </div>
        }

        @case ('fourLayout3') {
          <div class="grid grid-cols-2 gap-2 items-start">
        @for (im of firstN(4); track im.id) {
              <ng-container
                [ngTemplateOutlet]="imageTile"
                [ngTemplateOutletContext]="{
        $implicit: im,
        mode: 'grid',
        ar: '1 / 1'
        }"
              ></ng-container>
        }
          </div>
        }

        @default {
          <div class="grid grid-cols-2 gap-2">
            @for (im of images(); track im.id) {
              <ng-container
                [ngTemplateOutlet]="imageTile"
                [ngTemplateOutletContext]="{ $implicit: im, mode: 'grid' }"
              ></ng-container>
            }
          </div>
        }
      }
    </div>

  }

  <ng-template #imageTile let-im let-ar="ar" let-fillH="fillH">
    <div class="relative w-full" [class.h-full]="fillH" [style.border-radius.px]="cornerRadius()">
      @if (safeLink(im); as href) {
        <a [href]="href" target="_blank" rel="noopener noreferrer" class="block hover:opacity-90 transition" [class.h-full]="fillH">
          <img
            class="block w-full"
            [class.h-full]="fillH"
            [style.border-radius.px]="cornerRadius()"
            [style.object-fit]="'cover'"
            [style.aspect-ratio]="fillH ? null : ar"
            [style.filter]="im.title ? 'brightness(0.9)' : null"
            [src]="imgSrc(im)"
            [alt]="altText(im)"
            (error)="onImgError($event, im)"
          />
          @if (im.title) {
            <div class="inset-0 items-center text-white px-2 image-title">
              <span [style.font-family]="titleFont()">{{ im.title }}</span>
            </div>
          }
        </a>
      } @else {
          <img
            class="block w-full"
            [class.h-full]="fillH"
            [style.border-radius.px]="cornerRadius()"
            [style.object-fit]="'cover'"
            [style.aspect-ratio]="fillH ? null : ar"
            [style.filter]="im.title ? 'brightness(0.9)' : null"
            [src]="imgSrc(im)"
            [alt]="altText(im)"
            (error)="onImgError($event, im)"
          />
          @if (im.title) {
            <div class="inset-0 items-center text-white px-2 image-title">
              <span [style.font-family]="titleFont()">{{ im.title }}</span>
            </div>
          }
      }
    </div>
  </ng-template>

</div>
